// DetailsModal.js
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import HttpClient from '../../utils/HttpClient';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import nothoto from "../../Images/nophoto.jpg"
import { BorderBottom } from '@mui/icons-material';

const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            BorderBottom: 'solid 1px #000'
        },
    },
};

const dateTimeFormat = "DD-MM-YYYY, hh:mmA"

Modal.setAppElement('#root'); // Set the root element for accessibility



const BusinessFollowModal = ({ isOpen, closeModal, details }) => {


    const [tableData, setTableData] = useState([]);
    const [BcryptPassword, setBcryptPassword] = useState("")
    const navigate = useNavigate()

    const handleClickid = (id) => {
        navigate('/recently-added-user', { state: id })
    }

    // fetch Category Data
    const getCategoryData = async () => {
        // setIsLoading(true);

        const res = await HttpClient.requestData('single-user/' + details, 'GET', {});
        if (res && res?.status) {
            const token = res?.data?.[0]?.token
            const decoded = jwtDecode(token);
            setTableData(res?.data);
            setBcryptPassword(decoded?.password)
        }
    }
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = tableData?.[0]?.qrCode;
        link.download = tableData?.[0]?.qrCode;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        // getCategoryData();
    }, [details]);

    const columns = [
        {
            name: 'SL',
            selector: (row, index) => index + 1,
            width: "10%",
            // wrap: true
        },
        {
            name: 'Date & Time',
            selector: row => { return moment(row.createdOn).format(dateTimeFormat) },
            width: "20%",
            wrap: true
        },
        {
            name: 'Company Name',
            selector: row => row.followerData[0]?.companyName,
            width: "25%",
            wrap: true
        },
        // {
        //     name: 'Company Type',
        //     selector: row => row.followerData[0]?.companyTypeName,
        //     width: "20%",
        //     wrap: true
        // },
        {
            name: 'Person Name',
            selector: row => row.followerData[0]?.personName,
            width: "45%",
            wrap: true
        },
    ];

    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Details Modal"
            className=""
        >
            <a href='#' className='mtclose' onClick={closeModal}><i className="fa-solid fa-xmark"></i></a>


            <>
                <div className=' container'>
                    <div className=' row '>
                        <div className='col-12 d-flex justify-content-center '>
                            <h2 className='  border-bottom border-danger mb-3'>Follower&nbsp;({details?.length})</h2>

                        </div>
                        <hr />
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Date & Time Created :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1)}</p>
                        </div> */}
                        <DataTable
                            columns={columns}
                            data={details}
                            pagination
                            striped
                            customStyles={customStyles}
                        />
                    </div>
                </div>
            </>
        </Modal >

    );
};

export default BusinessFollowModal;
